export const getSpendingAccountsDescriptionTitles = (type: string) => {
  switch (type) {
    case 'health-care':
      return <span>
        Want to know about Health Care FSA (HCFSA)?
      </span>;
    case 'dependant-care':
      return <span>
        Want to know about Dependent Care FSA (DCFSA)?
      </span>;
    default:
      return <span></span>;
  }
};

export const getSpendingAccountsDescription = (type: string, more: boolean) => {
  switch (type) {
    case 'health-care':
      return <span>
        Under this plan, you may contribute pre-tax dollars to pay for certain 
        eligible health care expenses that are not covered by other insurance 
        plans. Contributions made to this plan can only be used to reimburse 
        qualified health care expenses (day care expenses are reimbursed through 
        the Dependent Care Flexible Spending Account).If you enroll in the Value 
        PPO, your Health Care Flexible

        {more && <>
          <span> Spending Account will be a Limited Purpose Account. Contributions 
            can be used for qualified dental and vision expenses, but can only be 
            used for eligible medical expenses once the medical plan deductible has 
            been met.
          </span>
          <div className="mt-10">
            Your elected annual contribution amount will be deducted in equal amounts from your paycheck. Please be careful when determining the amount that you wish to contribute to the plan, because the total amount you elect will be deducted for the year, regardless of when you make your election. For example, if you elect to contribute $1,200 effective July 1, the $1,200 will be deducted from your pay in equal installments of $200 per month for the remainder of the year. Also be aware that any remaining contribution amounts over $500 will be forfeited if not used during the plan year.
            If you experience a qualified change in status and you change your contribution amount, your per-pay-period deduction will be adjusted accordingly.
          </div>
          <div className="mt-10">
            Please note:
          </div>
          <span>
            <ul className="ms-5 mb-10">
              <li>
                <span>
                  If you begin contributions to a Health Care Flexible Spending Account 
                  (HCFSA), only those expenses incurred on or after the event date are 
                  eligible for reimbursement.
                </span>
              </li>
              <li>
                If you increase contributions to a HCFSA, only those expenses incurred 
                on or after the event date are eligible for reimbursement from the 
                increased deductions.
              </li>
              <li>
                Under IRS rules for flexible spending accounts, the expenses for a 
                domestic partner and your domestic partner’s dependents generally 
                cannot be reimbursed unless they are your dependents as determined 
                under Federal tax law.
              </li>
            </ul>
          </span>
        </>}
      </span>;
    case 'dependant-care':
      return <span>
        Under a dependent care spending account (DCFSA), you may contribute pre-tax 
        dollars to pay for certain eligible dependent care expenses. Contributions 
        made to your DCFSA can only be used to reimburse qualified dependent day 
        care expenses. They cannot be used to reimburse any medical care expenses. 
        (Health care expenses for your eligible dependents are reimbursed through the 
        
        {more && <>
          <span> health care spending account (HCFSA).)</span>
          <div className="mt-10">
            Your elected annual contribution amount will be deducted in equal amounts 
            from your weekly paychecks through mid-December (50 pay periods). Please be 
            careful when determining the amount that you wish to contribute to your DCFSA. 
            Any remaining contribution amounts will be forfeited if not used during the 
            plan year. Only expenses incurred after enrolling in the plan are eligible 
            for reimbursement. Please note your claim must be filed with the spending 
            account administrator by April 30 following the plan year.
          </div>
          <div className="mt-10">
            Important Reminder: Your annual DCFSA contributions are limited to $5,000.
          </div>
        </>}
      </span>;
    default:
      return <span></span>;
  }
};
